import React from 'react'

import { Body2, Box, Color, Display, FontWeight } from '@gousto-internal/citrus-react'
import type { DashboardExperienceOrderResponse } from '@library/api-dashboard-experience'
import { browserHistory } from 'react-router'
import { useOrderTracking } from '../../../hooks/useOrderTracking'

import { RecommendationRecipeCard } from '../RecommendationRecipeCard/RecommendationRecipeCard'

export type RecommendationSectionData = {
  collection: 'top picks' | 'limited edition'
  id: string
  title: string
  recipes: DashboardExperienceOrderResponse['recipes']
}

type RecommendationSectionProps = {
  orderId: string
  section: RecommendationSectionData
}

export const RecommendationSection = ({ orderId, section }: RecommendationSectionProps) => {
  const { trackRecommendedRecipeClick } = useOrderTracking()

  const handleRecipeClick = () => {
    trackRecommendedRecipeClick({
      orderId,
      collection: section.collection,
    })
    browserHistory.push(`/menu/${orderId}`)
  }

  return (
    <Box>
      <Body2
        color={Color.ColdGrey_900}
        fontWeight={FontWeight.Bold}
        style={{ marginBottom: '12px' }}
      >
        {section.title}
      </Body2>
      <Box
        aria-label={section.title}
        display={Display.Flex}
        gap={3}
        role="list"
        style={{
          overflowX: 'auto',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          scrollSnapType: 'x proximity',
          WebkitOverflowScrolling: 'touch',
          paddingBottom: '4px',
        }}
      >
        {section.recipes.map((recipe) => (
          <RecommendationRecipeCard key={recipe.id} onClick={handleRecipeClick} recipe={recipe} />
        ))}
      </Box>
    </Box>
  )
}
